<template>
    <div>
        <div class="main-article">
            <div class="article">
                <p class="sub-title">版权服务“一日达”</p>
                <p class="paragraph">
                    数字时代下，版权对企业发展的重要程度越来越高。但是多数企业往往面临内部版权专业人员少，外部版权服务机构不正规，业务服务能力弱等痛点。为满足企业日益增长的版权服务需求，北京市版权局授权北京市版权服务工作站协同各园区开展版权服务工作，并推出“版权服务一日达”业务。指为企业等各类权人，提供一天时间内，低成本、快速解决版权登记等相关的版权保护服务。辐射内容包括办理周期，费用及办理所需材料等。提供服务的单位，是由北京市版权局授权，予以设立的有资质的版权工作站单位，极大程度上满足企业等各类权利人对服务单位的身份信任、权威信任。如果需要该项服务，可直接与我们联系。我们将在一日内与您取得联系，并解决您的版权保护需求。
                </p>
            </div>
            <div class="article-picture">
                <div style="width: 400px;height: 300px;">
                    <img :src="article21"/>
                </div>
            </div>
        </div>
        <div class="main-article">
            <div class="article quick-response">
                <p class="sub-title">一日达业务特色</p>
                <ul>
                    <li>
                        <div class="desc-img">
                            <img width="100%" src="~@/assets/images/v2/article/characteristic1.png"/>
                        </div>
                        <p>#响应速度快</p>
                        <p>企业提出业务需求平均8小时内给予响应</p>
                    </li>
                    <li>
                        <div class="desc-img">
                            <img width="100%" src="~@/assets/images/v2/article/characteristic2.png"/>
                        </div>
                        <p>#服务能力强</p>
                        <p>提供服务的园区/机构均得到北京市版权局版权工作站授牌，并每年接受服务考核</p>
                    </li>
                    <li>
                        <div class="desc-img">
                            <img width="100%" src="~@/assets/images/v2/article/characteristic3.png"/>
                        </div>
                        <p>#收费透明</p>
                        <p>版权服务以公益服务为基础，大部分服务免费，部分服务按国家统一标准</p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="main-article">
            <div class="article">
                <p class="sub-title">版权服务一日达内容包括</p>
                <!-- <div>
                    <p class="paragraph2"><font class="service-name">版权咨询：</font>--版权登记、版权保护、版权金融、版权管理等方面的咨询与培训</p>
                    <p class="paragraph2"><font class="service-name">版权确权：</font>--版权登记、认证、存证服务</p>
                    <p class="paragraph2"><font class="service-name">版权维权：</font>--版权监测、取证固证、投诉下线、调解、诉讼等服务</p>
                    <p class="paragraph2"><font class="service-name">版权资产管理：</font>--资产盘点、台账管理、权利流转、管理制度等服务</p>
                </div> -->
                <ul class="service-list">
                    <li >
                        <p>版权咨询</p>
                        <p>版权登记、版权保护、版权金融、版权管理等方面的咨询与培训</p>
                    </li>
                    <li >
                        <p>版权确权</p>
                        <p>版权登记、认证、存证服务</p>
                    </li>
                    <li >
                        <p>版权维权</p>
                        <p>版权监测、取证固证、投诉下线、调解、诉讼等服务</p>
                    </li>
                    <li >
                        <p>版权资产管理</p>
                        <p>资产盘点、台账管理、权利流转、管理制度等服务</p>
                    </li>

                </ul>
            </div>
        </div>
        <div class="contact-information">
            <img :src="article22"/>
        </div>
    </div>
</template>

<script>
    import article21 from '@/assets/images/v2/article/article2-1.png';
    import article22 from '@/assets/images/v2/article/article2-2.png';
    import article23 from '@/assets/images/v2/article/article2-3.png';
    export default{
        name:"article2",
        data(){
            return{
                article21,article22,article23
            }
        }
    }
</script>
<style lang="less" scoped>
    .main-article{
        display: flex;
        padding: 50px 0;
    }
    .article{
        flex: 1;
        .sub-title{
            font-family: Source Han Sans CN;
            font-size: 24px;
            font-weight: 700;
            line-height: 36px;
            text-align: left;
            color: #666;
            padding: 30px 0 30px 0;
        }
        .paragraph{
            color: #999;
            font-family: Source Han Sans CN;
            font-size: 14px;
            font-weight: 700;
            line-height: 30px;
            text-align: left;
            text-indent: 28px;
            width: 664px;
        }
        .paragraph2{
            color: #999;
            font-family: Source Han Sans CN;
            font-size: 14px;
            font-weight: 700;
            line-height: 30px;
            text-align: left;
            text-indent: 50px;
            width: 664px;
        }
        .service-name{
            font-weight: 700;
            line-height: 30px;
            text-align: left;
            color: #666;
            text-indent: 22px;
        }
    }
    .quick-response{
        ul{
            display: flex;
        }
        ul li{
            width: 263px;
            text-align: left;
            p:nth-child(2){
                color: #666;
                font-size: 26px;
                font-weight: 700;
                line-height: 50px;
            }
            p:nth-child(3){
                color: #999;
                font-size: 14px;
                font-weight: 700;
                line-height: 35px;
            }
            margin-left: 114px;
            .desc-img{
                width: 80px;
                height: 80px;
            }
        }
        ul li:nth-child(1){
            margin-left: 50px !important;
        }
    }
    .contact-information{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 100px 0;
        img{
            height: 572px;
            height: 123px;
        }
    }
    .service-list{
        display: flex;
        li{
            width: 244px;
            height: 244px;
            background-image: url(@/assets/images/v2/article/article2-3.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            p:nth-child(1){
                font-family: Source Han Sans CN;
                font-size: 26px;
                font-weight: 700;
                line-height: 39px;
                color: #666;
                margin-top: 60px;
                
            }
            p:nth-child(2){
                font-family: Source Han Sans CN;
                font-size: 14px;
                font-weight: 700;
                line-height: 30px;
                color: #999;
                width: 169px;
            }

        }
        li:nth-child(n+2){
            margin-left: 25px;
        }
    }
</style>